<!-- 骏达定制打印销售单 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printSaleContent" class="print-zone">
            <div style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view" id="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                    </div>
                    <div class="print-orderDetail">
                        <div class="row">
                            <div class="col col-7" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_l">客户名称：</label>
                                <div class="grid-content cname">{{ orderData.EntpCusName }}</div>
                            </div>
                            <div class="col col-5">
                                <label class="label_r w40">支付：</label>
                                <div class="grid-content">{{ orderData.PayTypeName }}</div>
                            </div>
                            <div class="col col-6">
                                <label class="label_r w40">发货：</label>
                                <div class="grid-content">{{ orderData.ShipTypeName }}</div>
                            </div>
                            <div class="col col-6 barfa">
                                <div class="grid-content"><svg id="barcode" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-7" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_l">客户电话：</label>
                                <div class="grid-content cname">{{ orderData.PhoneNum }}</div>
                            </div>
                            <div class="col col-5">
                                <label class="label_r w40">物流：</label>
                                <div class="grid-content">{{ orderData.LogisticName }}</div>
                            </div>
                            <div :class="!isEditOpenTime ? 'col col-6' : 'autoWH'">
                                <label class="label_r w40">日期：</label>
                                <el-date-picker
                                    v-if="isEditOpenTime"
                                    v-model="orderData.CreateTime"
                                    value-format="yyyy-MM-dd HH:mm"
                                    type="datetime"
                                    size="small"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                                <div v-if="!isEditOpenTime" class="grid-content">{{ orderData.CreateTime }}</div>
                            </div>
                            <div class="col col-6">
                                <label class="label_r"></label>
                                <div class="grid-content"></div>
                            </div>
                        </div>
                        <div :class="orderData.IsModified ? 'row MAnchor' : 'row'">
                            <div v-if="orderData.IsModified" class="isModif">改</div>
                        </div>
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="4%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="17%">
                                    <div><b>编码</b></div>
                                </td>
                                <td width="17%">
                                    <div><b>名称</b></div>
                                </td>
                                <td width="17%">
                                    <div><b>车型</b></div>
                                </td>
                                <!-- <td width="9%">
                                    <div><b>规格</b></div>
                                </td> -->
                                <td width="8%">
                                    <div><b>产地</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>数量</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="7%">
                                    <div><b>单价</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>金额</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>仓位</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.AutoSerise }}</td>
                                <!-- <td>{{ AP.Size }}</td> -->
                                <td>{{ AP.Origin }}</td>
                                <td>{{ AP.Count }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>{{ AP.Price }}</td>
                                <td>{{ (AP.Count * AP.Price).toFixed(2) }}</td>
                                <td>{{ AP.GoodsLocation }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="11">
                                    <div style="display: inline-block; text-indent: 35px; width: 40%">
                                        <span tdata="pageNO" format="#">第#页</span> / <span tdata="pageCount" format="#">共#页</span>
                                    </div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="6" tdata="SubSum" format="#">小计数量：#</div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="9" tdata="SubSum" format="#,##0.00">小计金额：###</div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div id="foot">
                    <div class="order-remark btd">
                        <div style="width: 57.33333%">人民币大写：{{ capitalAmount }}</div>
                        <div style="width: 16.66667%">{{ orderData.ShipAmount > 0 ? '运费：' + orderData.ShipAmount : '' }}</div>
                        <div style="width: 16.66667%">数量：{{ orderData.TotalCount }}</div>
                        <div style="width: 26.66667%; text-align: right">金额：{{ orderData.ActuallyAmount }}</div>
                        <div style="width: 16.66667%">{{ showDisc && orderData.DiscountAmount > 0 ? '优惠：' + orderData.DiscountAmount : '' }}</div>
                    </div>
                    <div class="order-remark fwb" style="padding: 5px 0; font-size: 20px">
                        <div style="width: 99%">出库备注：{{ orderData.Remark }}</div>
                    </div>
                    <!--    脚注    -->
                    <div
                        class="order-remark"
                        slot="content"
                        v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet"
                        v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                    >
                        <!-- {{ config.RValue }} -->
                    </div>
                    <div class="order-setcontent" v-if="isEditConfig">
                        <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                    </div>
                    <div class="order-remark fwb" style="font-size: 14px">
                        <div style="width: 16.66667%">开单人：{{ nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName }}</div>
                        <div style="width: 16.66667%">点货：</div>
                        <div style="width: 16.66667%">验货：</div>
                        <div style="width: 16.66667%">送货：</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   标题   -->
                <div class="re-set">
                    <el-button
                        class="btn-primary"
                        size="small"
                        @click="isEditTitle = true"
                        v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button
                        class="btn-primary"
                        size="small"
                        @click="setConfig()"
                        v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet"
                        >编辑脚注</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" size="small" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime"
                        >设置开单时间</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
                <div class="sort-set">
                    <el-button class="btn-primary" size="small" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div v-if="printType == 1 && !isEditConfig && !isEditTitle" class="re-submit">
                <el-button class="btn-primary" size="small" v-print="'#printSaleContent'" @click="returnOrderList(true)" v-if="isDefaultSet">打印并返回列表</el-button>
                <el-button class="btn-primary" size="small" v-print="'#printSaleContent'" @click="continueToOrder()" v-if="isDefaultSet">打印并继续开单</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="isDefaultSet">返回列表</el-button>
                <el-button class="btn-primary" size="small" @click="returnOrderList(true)" v-if="!isDefaultSet">打印并返回列表(F1)</el-button>
                <el-button class="btn-primary" size="small" @click="continueToOrder()" v-if="!isDefaultSet">打印并继续开单(F2)</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="!isDefaultSet">返回列表(F3)</el-button>
            </div>
            <div v-else-if="!isEditConfig && !isEditTitle" class="re-submit">
                <el-button class="btn-primary" size="small" @click="lodopSalePrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" size="small" @click="printedRecord" v-print="'#printSaleContent'" v-else>打印</el-button>
                <el-button size="small" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        },
        //是否显示优惠
        showDisc: {
            type: Boolean,
            default: true
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            userMsg: userMsg,
            orderData: {},
            allPrice: 0,
            allNum: 0,
            company: userMsg.EntpName,
            permission: {},
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '销售单'
            }, //标题配置
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            nameConfig: false,
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            amountConfig: false,
            imgUrl: '',
            sortField: 'sortnum', //排序
            isPrint: false,
            isPreview: false,
            isDefaultSet: false
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl || !this.isInit) return;
            this.$nextTick(function () {
                JsBarcode('#barcode', value.OrderCode, {
                    width: 1.1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            let sortField = this.$util.getLocalStorage('sale_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
                if (this.printType == 1 && !this.isDefaultSet) {
                    document.addEventListener('keydown', this.handleKeyEvent_Print);
                }
            });
        },
        handleKeyEvent_Print(e) {
            let that = this;
            let currtPrint = document.querySelector('#printSaleContent');
            //当打印弹窗关闭时载触发当前事件时移除监听
            if (!currtPrint || !currtPrint.parentElement || !currtPrint.parentElement.domInserted) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                return;
            }
            if (that.loading || that.isEditConfig || that.isEditTitle) return;
            let key = window.event.keyCode;
            e.preventDefault();
            // 打印并继续开单(F1)
            if (key == 112) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(true);
            }
            // 打印并返回列表(F2)
            else if (key == 113) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.continueToOrder();
            }
            // 返回列表(F3)
            else if (key == 114) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(false);
            }
            return;
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxssj', 'dyxs', 'dyshbt', 'dyywync', 'dydxje', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxssj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxs':
                                    this.config = data[i];
                                    break;
                                case 'dyshbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '销售单';
                                    break;
                                case 'dyywync':
                                    this.nameConfig = result;
                                    break;
                                case 'dydxje':
                                    this.amountConfig = result;
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopSalePrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                LODOP.PRINT_INIT('打印销售单');

                let topStyle = `
                    .print-title-view {
                        width: 790px;
                        position: relative;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 0;
                        padding-top:5px;
                    }
                    .print-title-view .order-code{
                        display: none;
                    }                    
                    .print-title {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                        padding-bottom: 25px;
                    }                    
                    .print-orderDetail {
                        width: 762px;
                        margin-bottom: 0px;
                        font-size: 14px !important;
                        color: #000;
                        padding: 0;
                        padding-left: 5px;
                        margin-right: 20px;
                    }
                    .print-orderDetail .barfa{
                        display:none;
                    }
                    .print-orderDetail .row {
                        margin-left: -10px;
                        margin-right: -10px;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        margin-bottom: 5px;
                    }

                    .print-orderDetail .row::after,
                    .print-orderDetail .row::before {
                        display: table;
                        content: '';
                        clear: both;
                    }
                    .print-orderDetail .row .col {
                        float: left;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 18px;
                        height: 18px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .print-orderDetail .col-5 {
                        width: 20.83333%;
                    }
                    .print-orderDetail .col-6 {
                        width: 25%;
                    }
                    .print-orderDetail .col-7 {
                        width: 29.16667%;
                    }
                    .print-orderDetail .col-8 {
                        width: 33.33333%
                    }
                    .print-orderDetail .col-9 {
                        width: 37.5%;
                    }   
                    .print-orderDetail .row .height40 {
                        height: 40px !important;
                    }

                    .print-orderDetail .row .col .label_l {
                        width: 70px;
                        text-align: left;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .label_r {
                        width: 70px;
                        text-align: right;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .w40{width:40px !important;}
                    .w60{width:60px !important;}
                    .print-orderDetail .row .col .grid-content {
                        display: inline-block;
                        min-height: 18px;
                        border-radius: unset;
                        line-height: 18px;
                    } 
                    .print-orderDetail .row .col .debts{
                        padding-top: 3px;
                    }
                    .print-orderDetail .row .col .grid-content::after,
                    .print-orderDetail .row .col .grid-content::before {
                        display: table;
                        content: '';
                        clear: both;
                    } 
                    .print-orderDetail .rkCol{
                        height: auto !important;
                    }
                    .print-orderDetail .rkCol .grid-content{
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: break-spaces !important;
                        white-space: pre-wrap !important;
                        width: 70% !important;
                    }   
                    .isModif{
                        display: none;
                    }
                    .cname {
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: pre-wrap !important;
                        white-space: break-spaces !important;
                        width: 70%;
                    }                    
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break : break-all;word-wrap: break-word;
                    }                    
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }                
                `;

                let footStyle = `
                    .order-remark {
                        width: 762px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        padding-top: 3px;
                        color: #000;
                        width: 100%;
                        margin: 0 auto;
                        font-size: 15px;
                    }    
                    .fwb {
                        font-weight: bold;
                        font-size:16px;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;

                // LODOP.ADD_PRINT_BARCODE(10, 5, 100, 100, 'QRCode', this.orderData.OrderCode);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                // LODOP.ADD_PRINT_BARCODE(40, 570, 187, 40, '128Auto', this.orderData.OrderCode);
                LODOP.ADD_PRINT_BARCODE(30, 550, 216, 40, '128Auto', this.orderData.OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                let contentHeight = document.getElementById('printSaleContent').clientHeight;
                let topHeight = document.querySelector('#printSaleContent #top').clientHeight;
                let tableHeight = document.querySelector('#printSaleContent #table').clientHeight;
                let footHeight = document.querySelector('#printSaleContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;

                if (this.orderData.IsModified) {
                    //画椭圆，因为打印插件不支持css的border-radius 所以这里用了他自身的画图像的接口
                    LODOP.ADD_PRINT_SHAPE(3, topHeight - 35, 658, 41, 27, 'solid', 2, 'black');
                    LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                    LODOP.ADD_PRINT_TEXT(topHeight - 29, 673, 41, 41, '改'); //增加纯文本项
                    LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                }

                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    // //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                    // printTableH = 950;
                }

                LODOP.ADD_PRINT_HTM('5', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printSaleContent #top').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_TABLE(
                    topHeight + 20,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printSaleContent #table').innerHTML
                );
                // //次页开始的上边距偏移量
                // LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight - 2);
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${footStyle}</style>` + document.querySelector('#printSaleContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);

                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);

                // //预览
                if (this.isPreview) LODOP.PREVIEW();
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 0 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        continueToOrder() {
            if (!this.isDefaultSet) {
                this.lodopSalePrint();
                setTimeout(() => {
                    this.$emit('closePrintDialog', 'continueToOrder');
                }, 2000);
            } else {
                this.loading = true;
                this.$util
                    .printedRecord(
                        {
                            OrderId: this.printIds[0],
                            Type: 0
                        },
                        true
                    )
                    .then(res => {
                        setTimeout(() => {
                            this.$emit('closePrintDialog', 'continueToOrder');
                        }, 2000);
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }
        },
        returnOrderList(delay) {
            if (delay) {
                if (!this.isDefaultSet) {
                    this.lodopSalePrint();
                    setTimeout(() => {
                        this.$router.push('/salesManage/salesOrder');
                    }, 2000);
                } else {
                    this.loading = true;
                    this.$util
                        .printedRecord(
                            {
                                OrderId: this.printIds[0],
                                Type: 0
                            },
                            true
                        )
                        .then(res => {
                            setTimeout(() => {
                                this.$router.push('/salesManage/salesOrder');
                            }, 2000);
                        })
                        .catch(err => {
                            this.loading = false;
                        });
                }
            } else {
                this.$router.push('/salesManage/salesOrder');
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetJDSaleOrderPrint',
                    data: {
                        EntpCusOId: this.printIds[0],
                        SortField: this.sortField
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    this.capitalAmount = this.$util.moneyToCapital(this.orderData.ActuallyAmount);
                    if (res.data.DetailList == 0) {
                        this.$util.warningMsg('该订单的商品已经全部退货！');
                    }
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopSalePrint();
                            }, 500);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        setSortField(field) {
            this.$util.setLocalStorage('sale_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>

<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
    .order-code {
        display: inline-block;
        margin-bottom: -50px;
        padding-left: 5px;
    }
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
    padding-right: 5px;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 3px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
    padding-bottom: 25px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    position: relative;
}

.print-table-main {
    width: 792px;
    font-size: 14px;

    .div-table-cell {
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        word-break: break-all;
        word-wrap: break-word;
        height: auto;
        // line-height: 30px;
        line-height: 25px;
        padding-left: 1px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .tableConten {
        .div-table-cell {
            // line-height: 14px;
            // padding-top: 3px;
            line-height: 14px;
            //上下垂直居中
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            padding-bottom: 5px;
            padding-top: 5px;
        }
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
.fwb {
    font-weight: bold;
    font-size: 16px;
}
.btd {
    border-bottom: 1px dashed #000;
    font-weight: bold;
}

.print-orderDetail {
    // margin-bottom: 10px;
    font-size: 14px;
    color: #000;
}
.print-orderDetail .row {
    margin-left: -10px;
    margin-right: -10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.print-orderDetail .row::after,
.print-orderDetail .row::before {
    display: table;
    content: '';
    clear: both;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-orderDetail .col-5 {
    width: 20.83333%;
}
.print-orderDetail .col-6 {
    width: 25%;
}
.print-orderDetail .col-7 {
    width: 29.16667%;
}
.print-orderDetail .col-9 {
    width: 37.5%;
}
// .print-orderDetail .qrcode-canvas,
// .print-orderDetail .qrcode-image {
//     width: 40px;
//     height: 40px;
//     display: inline-block;
//     vertical-align: top;
// }

.print-orderDetail .row .height40 {
    height: 40px !important;
}
.print-orderDetail .row .barfa {
    height: auto;
    position: absolute;
    right: -10px;
    top: 30px;
}

.print-orderDetail .row .col .label_l {
    width: 70px;
    text-align: left;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.print-orderDetail .row .col .label_r {
    width: 70px;
    text-align: right;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.w60 {
    width: 60px !important;
}
.w40 {
    width: 40px !important;
}
.autoWH {
    width: auto;
    height: auto;
}
.print-orderDetail .row .col .grid-content {
    display: inline-block;
    min-height: 18px;
    line-height: 18px;
    border-radius: unset;
}
.print-orderDetail .row .col .debts {
    padding-top: 3px;
}
.print-orderDetail .row .col .grid-content::after,
.print-orderDetail .row .col .grid-content::before {
    display: table;
    content: '';
    clear: both;
}
.print-orderDetail .rkCol {
    height: auto !important;
}
.print-orderDetail .rkCol .grid-content {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    white-space: break-spaces !important;
    width: 70% !important;
}
.MAnchor {
    position: relative;
    padding-bottom: 10px;
}
.isModif {
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -moz-border-radius: 50%;
    padding: 3px 11px;
    color: red;
    border: solid 2px red;
    position: absolute;
    right: 80px;
    bottom: 4px;
}
.cname {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    white-space: break-spaces !important;
    width: 70%;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
